import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'

@Injectable()
export class LoadingBtnService {
  constructor (private http: Http) {
  }

  portScan (device_list?:string[]) {
    return this.http.post<void>('/portcontrol/scan-command/send', {device_list})
  }
}
